import React from "react";
import { PageSection } from "../common/pageSection/PageSection";
import { useQuery } from "@apollo/client";
import { GET_CONTACTSECTION } from "../../graphql/queries";
import { ContactSection } from "../../graphql/schema";
import {
  makeStyles,
  Text,
} from "@fluentui/react-components";
import { ContactForm } from "./ContactForm";
import { useCmsLocale } from "../../i18n/cmsLocale";

const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: "600px",
  },
});
export const Contact = (): JSX.Element => {
  const classes = useStyles();
  const locale = useCmsLocale();
  const { data, loading, error } = useQuery(GET_CONTACTSECTION, { variables: { locale } });
  if (loading || error || !data.contactSection) return <></>;
  const contactSection: ContactSection = data.contactSection;

  return (
    <PageSection id="contact" className={classes.wrapper}>
      <Text size={800} align="center" weight="bold">
        {contactSection.title ?? ""}
      </Text>
      <Text size={400} align="center">
        {contactSection.subHeading ?? ""}
      </Text>
      <ContactForm contactSection={contactSection} />
    </PageSection>
  );
};
